import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  SearchBoxCont,
  SearchButton,
  SearchInput,
  SearchInputIcon,
  SearchInputCont,
} from './SearchBox.styles';
import { useSurveyTable } from '../../hooks';
import { ISurveyFilters } from '../../services/surveys';
import SearchIcon from '@/assets/icons/searchIcon.svg?react';

interface ISearchBox {
  searchPhrase: (search: ISurveyFilters) => void;
  placeholder: string;
  isIcon?: boolean;
  filterName: string;
  isButtonAvailable?: boolean;
}

const SearchBox: FC<ISearchBox> = ({
  searchPhrase,
  placeholder,
  isIcon = false,
  filterName,
  isButtonAvailable = 'true',
}) => {
  const { t } = useTranslation();
  const { getAppliedFilters } = useSurveyTable();
  const filters = getAppliedFilters();
  const initialValue = filters[filterName] || null;
  const { register, handleSubmit } = useForm({
    defaultValues: {
      [filterName]: initialValue,
    },
  });

  const doSearch = ({ [filterName]: search }: ISurveyFilters) => {
    if (!search) {
      return searchPhrase({ [filterName]: null });
    }
    return searchPhrase({ [filterName]: search.trim(), pageNo: null });
  };

  return (
    <form onSubmit={handleSubmit(doSearch)}>
      <SearchBoxCont>
        <SearchInputCont>
          <SearchInput
            data-testid="SearchBoxInput"
            {...register(filterName)}
            placeholder={placeholder}
            width="305px"
            padding={isIcon ? '12px 12px 12px 44px' : '12px'}
          />
          {isIcon ? (
            <SearchInputIcon>
              <SearchIcon />
            </SearchInputIcon>
          ) : null}
        </SearchInputCont>
        {isButtonAvailable && (
          <SearchButton data-testid="SearchBoxButton" type="submit">
            <SearchIcon />
            {t('surveys.table.metadata.search')}
          </SearchButton>
        )}
      </SearchBoxCont>
    </form>
  );
};

export default SearchBox;
